module.exports = __webpack_public_path__ + "img/image-icon.197145f6.svg";